import { ActionTypes } from "../constants/action-types";
import { createAction } from "redux-actions";
import { getConnectionStrength, getEstimatedProbability } from "../api/ItemScoringApi";

const api = {
  [ActionTypes.getConnectionStrength]: (itemId: string) => getConnectionStrength(itemId),
  [ActionTypes.getEstimatedProbability]: (itemId: string) => getEstimatedProbability(itemId),
};

const actions: any = { ...api };

Object.keys(actions).forEach((type) => {
  actions[type] = createAction(type, actions[type]);
});

export default actions;
